import { Slide } from "react-awesome-reveal";
// 
import "styles/roadmap.css";


// -------- roadMap -----
const RoadMap = () => {
    // ========== data ==============
    let data = [
        {
            percent: "Already Done",
            heading: "WELCOME TO THE ARMY",
            perce: "Early Q1 2022",
            body: (
                <>
                    <p>
                        From all corners of the Galaxy, the last Space Warriors are regrouping to form the ultimate stronghold. They have taken shelter on Discord and The Army is assembling now
                    </p>
                </>
            ),
        },
        {
            percent: "Already Done",
            heading: "AS AN ARMY, WE MOVE AS ONE",
            perce: "Early Q1 2022",
            externalLink: `https://snapshot.box/#/s:space-warriors.eth`,
            body: (
                <>
                    <p>
                        Launch of the Space Warriors GAME DAO: Implementation of voting and suggestions systems. Warriors will have the right to participate in the decisions that will shape the video game: from game type to platform and much more. -All the while, we'll be working on developing the first community-built video game, and this process will be ongoing until completion.
                    </p>
                </>
            ),
        },
        {
            percent: "Already Done",
            heading: "METAVERSE TAKEOVER",
            perce: "Early Q1 2022",
            externalLink: `https://www.sandbox.game/en/experiences/space-warriors-club/d5e6b915-41d6-4218-8034-f659debaed9d/page/`,
            body: (
                <>
                    <p>
                        Collectively, we will elect the Metaverse upon which the Space Warriors Club HQ will be built, and we'll buy a piece of that land.
                    </p>
                </>
            ),
        },
        {
            percent: "Already Done",
            heading: "TIME TO SHARE THE LOOT",
            perce: "End of Q1 2022",
            externalLink: `https://www.sandbox.game/en/experiences/space-warriors-club/d5e6b915-41d6-4218-8034-f659debaed9d/page/`,
            body: (
                <>
                    <p>
                        The Army wallet will be funded with 10% of all secondary sales royalties. This wallet will be dedicated to funding the Space Warriors Club activities. These include building the metaverse, In Real Life events, conference, and much more.
                    </p>
                </>
            ),
        },
        {
            percent: "Already Done",
            heading: "HOP IN WARRIOR, WE ARE GOING FOR A RIDE",
            perce: "Q1 2022",
            externalLink: `https://opensea.io/collection/spacewarriors-spaceships`,
            body: (
                <>
                    <p>
                        If you minted, The council will airdrop the spaceships of each faction to its most loyal warrior holders.
                    </p>
                </>
            ),
        },
        {
            percent: "Already Done",
            heading: "CHECK MY GALACTIC DRIP",
            perce: "Q2 2022",
            externalLink: `https://opensea.io/collection/swc-ebook`,
            body: (
                <>
                    <p>
                        The official Army merchandise will be released. You will have access to goodies and a long-forgotten book, which is the last remaining archive of the Space Warriors' history.
                    </p>
                </>
            ),
        },
        {
            percent: "Already Done",
            heading: "DRINKS ON US BOIZ",
            perce: "Q3 2022",
            externalLink: `https://www.sandbox.game/en/experiences/space-warriors-club/d5e6b915-41d6-4218-8034-f659debaed9d/page/`,
            body: (
                <>
                    <p>
                        Launch of the metaverse hangout. Built on the metaverse chosen in step 2, the exclusive Space Warriors Club will finally become a place, and will officially exist in the metaverse, all warriors will be able to access it. This virtual land will be a place of union and discussion. It will be used to announce future e-sport and gaming events and special giveaways.
                    </p>
                </>
            ),
        },
        {
            percent: "Currently under development",
            heading: "Time to Play",
            perce: "TBA",
            notDone: true,
            body: (
                <>
                    <p>
                        The final goal of the Space Warriors Club: warriors will be able to experience their custom-built video game. They will be able to compete in-game for rewards coming from the army wallet or to implement many other utilities, depending on what warriors decide
                    </p>
                </>
            ),
        },
    ];
    return (
        <section id="roadMap">
            <div className="cs_container">
                <div className="sec_heading_wrapper">
                    <h1 className='font_spaced sec_heading'>Roadmap</h1>
                </div>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade active show" id="Launch-Roadmap">
                        <div className="road-map-content">
                            <div className="line-up">
                                {data?.map((item, i) => (
                                    <Slide key={i} direction='up' cascade damping={0.4} delay={(i / 2) * 100} duration={800 + ((i / 2) * 100)} triggerOnce>
                                        <div className="line-up-content">
                                            <div className="line-up-content-circle">
                                                <div className="line-up-content-circle-inner"></div>
                                            </div>
                                            <div className="line-up-content-description">
                                                <div className="d_flex align-items-center flex_wrap"
                                                style={{
                                                    gap: "15px",
                                                    padding: "0 0 10px 0",
                                                    flexWrap: "wrap"
                                                }}
                                                >
                                                {item?.externalLink && (
                                                    <a
                                                        href={item?.externalLink}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="cta-btn"
                                                        style={{
                                                            padding: "8px 12px",
                                                            fontSize: "16px",
                                                            minHeight: "28px",
                                                        }}
                                                        >
                                                        <div className="div-hide">
                                                          <div className="cta-btn-text">Click Here to check</div>
                                                          <div className="cta-btn-top-text">Click Here to check</div>
                                                        </div>
                                                    </a>)}
                                                {item?.percent && (<h3 className="d_flex align-items-center">
                                                    {item?.notDone ? item?.percent :
                                                    <strike>
                                                        {item?.percent}
                                                    </strike>}
                                                </h3>)}

                                                </div>
                                                <h4 className='font_spaced'>{item?.heading}</h4>
                                                <div className='font_digital'>
                                                    {item?.body}
                                                </div>
                                            </div>
                                        </div>
                                    </Slide>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default RoadMap